export const accounts = {
  userName: 'admin',
  password: '$2a$12$Ps6MS3bs/e8z6Z1OELEgaeaaEdllZ6cvlTxzenHk1zHwsagsNQ6Ae',
};
